import Vue from 'vue';

// APP
import App from '@/App.vue';

// ROUTER
import router from '@/router/index';

// STORE
import store from '@/store/index';

// PLUGINS
import '@/plugins/element';

// STYLES
import '@/assets/scss/styles.scss';

// i18n
import i18n from '@/i18n';

import VueProgressBar from 'vue-progressbar';

const progressbarOptions = {
  color: '#3498db',
  failedColor: '#D80F16',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  }
};

// ERROR TRACKING
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

if (process.env === 'production') {
  Sentry.init({
    dsn: 'https://a5d203c3b8924ea881672fb1d5a4a4e9@sentry.io/1477730',
    integrations: [new Integrations.Vue({ Vue, attachProps: false })]
  });
}

/**
 * Use Plugins
 */
Vue.use(VueProgressBar, progressbarOptions);

Vue.prototype.$store = store;

// CONFIG
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  localStorage,
  render: h => h(App)
}).$mount('#app');
